export default __webpack_public_path__ + "locales/si/DowngradePlanDialog.json?hash=d26745a76ba1595b8062ae686fdfad9d";